import { dayjs } from '@2wunder/klarx-tool'
import { Space, Tag } from 'antd'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import useTranslation from 'app/lib/hooks/useTranslation'
import React from 'react'

import { MemberProps } from '../../convention'

type Props = {
  startDate?: Dayjs
}
const AFTERNOON_THRESHOLD = 12 // 12:00 AM
export const now = () => dayjs() // needed for mocking in specs

const GuaranteedTag: React.FC<MemberProps<Pick<ILineItem, 'earliestAvailableDateTime'>, Props>> = ({
  member,
  props: { startDate }
}) => {
  const { tRecordType } = ToolBox.useString()
  const { generateId } = ToolBox.useId()
  const { tComponent } = useTranslation({
    componentType: 'data_display',
    scope: 'list.availability',
    recordType: RecordType.line_item
  })
  const testId = generateId({
    recordType: RecordType.line_item,
    id: 'list.availability',
    componentType: 'data_display'
  })

  const earliestAvailableDate = dayjs(member?.earliestAvailableDateTime)

  const isAvailable = React.useMemo(() => {
    if (!earliestAvailableDate || !startDate) return

    return startDate.isSameOrAfter(earliestAvailableDate, 'days')
  }, [member?.earliestAvailableDateTime, startDate])

  const dayTime = () => {
    const availabilityDate = earliestAvailableDate
      .clone()
      .set('hour', 0)
      .set('minute', 0)
      .set('second', 0) // set to midnight

    if (availabilityDate.isSameOrAfter(now(), 'days') && availabilityDate.diff(now(), 'days') < 1) {
      const id = earliestAvailableDate.get('hours') < AFTERNOON_THRESHOLD ? 'morning' : 'afternoon'
      return ` ${tComponent({ id })}`
    }
    return ''
  }
  const formattedDate = `${earliestAvailableDate.calendar()} ${dayTime()}`

  return (
    <If condition={member?.earliestAvailableDateTime}>
      <Choose>
        <When condition={isAvailable}>
          <Tag color="green">
            {tRecordType(RecordType.category_segment, 'guaranteed_availability_form', {
              date: formattedDate
            })}
          </Tag>
        </When>
        <Otherwise>
          <Space direction="vertical" size="small">
            <Tag color="blue">
              {tRecordType(RecordType.category_segment, 'guaranteed_availability_form', {
                date: formattedDate
              })}
            </Tag>
            <p data-testid={testId}>
              {tRecordType(RecordType.category_segment, 'has_no_guarantee_description', {
                strong: (val: string) => <strong>{val}</strong>
              })}
            </p>
          </Space>
        </Otherwise>
      </Choose>
    </If>
  )
}

export default GuaranteedTag
